import styled from 'styled-components'

interface MessageStyleProps {
  featured: boolean
}

export const StyledMessage = styled.div<MessageStyleProps>`
  text-align: left;
  background: transparent;
  position: relative;
  padding: 8px 6px;
  border-bottom: solid 1px rgba(164, 177, 180, 0.5);

  ${(p) =>
    p.featured &&
    `
    background: #3762e3 !important;
    position: sticky;
    top: 0;
    left: 0;
    right: 8px;
    z-index: 20;
    border-bottom: solid 3px #ecf1f2;
    `}

  &:hover {
    background: #edf4f6;
  }

  :last-child {
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }

  :first-child {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }

  .message {
    padding: 8px;
    margin: 0 6px;
    color: ${(props) => (props.featured === true ? '#FFF' : '#3c3c3c')};
    font-size: 14px;
  }
  .sender {
    font-size: 12px;

    .name {
      margin-top: 3px;
      color: ${(props) => (props.featured === true ? '#FFF' : 'black')};
      text-transform: capitalize;
    }

    .timestamp {
      font-size: 10px;
      color: ${(props) => (props.featured === true ? '#FFF' : '#999999')};
    }
  }
  .profile {
    margin: 0 4px;
    padding: 8px;
    .avatar {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 50%;
    }
  }
  .review-container {
    position: absolute;
    top: 12px;
    right: 10px;
    z-index: 1;
    display: flex;
    align-items: center;

    .iconBtn {
      border: solid 1px #b2bcc4;
      outline: none;
      background: transparent;
      border-radius: 4px;
      height: 28px;
      width: 28px;
      margin: 0 4px;
      &:hover {
        border-color: #35606d;
        opacity: 0.85;
      }

      svg {
        height: 100%;
        width: 100%;
      }
    }

    .switch-group span {
      font-size: 12px;
      line-height: 100%;
    }
  }
`
